import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(({ spacing }) => ({
  fileContainer: {
    maxWidth: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  fileLeft: {
    justifyContent: "start",
  },
  fileRight: {
    justifyContent: "end",
  },
  actionButtons: {
    display: "flex",
    flexDirection: "row",
    marginRight: spacing(1),
  },
}));
